<div class="catalog-container">
  <div class="catalog-content">
    <div class="filter-section" *ngIf="!loading && !error">
      <umkt-custom-input
        [placeholder]="'shared.placeholders.searchKeyword' | i18n"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange($event)"
        [showClearButton]="true"
        [showSearchIcon]="true"
        type="text"
      >
      </umkt-custom-input>
      <div class="separator">|</div>
      <div class="category-filter">
        <select
          [(ngModel)]="selectedCategory"
          (ngModelChange)="onCategoryChange($event)"
          class="category-select"
        >
          <option value="">{{ 'pages.catalog.categories.all' | i18n }}</option>
          <option *ngFor="let category of categories" [value]="category">
            {{ category }}
          </option>
        </select>
      </div>

      <label class="seller-mode-switch" [class.active]="sellerMode" *ngIf="isSellerRoute">
        <input
          type="checkbox"
          class="seller-mode-switch__input"
          [checked]="sellerMode"
          (change)="toggleSellerMode()"
        />
        <span class="seller-mode-switch__track" aria-hidden="true">
          <span class="seller-mode-switch__thumb"></span>
        </span>
        <span class="seller-mode-switch__label">
          {{
            (sellerMode
              ? 'pages.catalog.seller.exitMode'
              : 'pages.catalog.seller.enterMode') | i18n
          }}
        </span>
      </label>
    </div>

    <div
      class="seller-panel"
      *ngIf="isSellerRoute && sellerMode && !loading && !error"
    >
      <div class="seller-panel-top">
        <div class="seller-code-field">
          <umkt-custom-input
            [placeholder]="'pages.catalog.seller.codePlaceholder' | i18n"
            [ngModel]="sellerCode"
            (ngModelChange)="onSellerCodeChange($event)"
            (inputBlur)="onSellerCodeBlur()"
            (searchSubmit)="lookupSellerFromSearch()"
            [showClearButton]="false"
            [maxlength]="5"
            [restrictToAlphanumeric]="true"
            [floatingLabel]="true"
            [error]="showSellerCodeRequiredError"
            type="text"
          >
          </umkt-custom-input>

          <div class="seller-lookup-status" *ngIf="sellerLookupLoading">
            {{ 'pages.catalog.seller.verifying' | i18n }}
          </div>

          <span
            class="seller-code-required-error"
            *ngIf="showSellerCodeRequiredError"
          >
            {{ 'pages.catalog.seller.codeRequiredWithCart' | i18n }}
          </span>

          <p class="seller-name success" *ngIf="seller?.name && !sellerLookupLoading">
            {{ 'pages.catalog.seller.nameLabel' | i18n }} {{ seller?.name }}
          </p>

          <p class="seller-name error" *ngIf="sellerLookupError && !sellerLookupLoading && !showSellerCodeRequiredError">
            {{ sellerLookupError }}
          </p>
        </div>

        <button
          type="button"
          class="seller-cart-toggle"
          [class.expanded]="sellerCartExpanded"
          [attr.aria-expanded]="sellerCartExpanded"
          (click)="toggleSellerCart()"
        >
          <span class="seller-cart-toggle__label">
            {{
              (sellerCartExpanded
                ? 'pages.catalog.seller.hideCart'
                : 'pages.catalog.seller.showCart') | i18n
            }}
            <span class="mini-cart-count" *ngIf="totalCartItems > 0">
              {{ totalCartItems }}
            </span>
          </span>
          <umkt-icon
            class="seller-cart-toggle__chevron"
            [icon]="{ name: 'bi bi-chevron-down', type: 'bootstrap-icons' }"
            size="sm"
          ></umkt-icon>
        </button>
      </div>

      <div class="seller-mini-cart" *ngIf="sellerCartExpanded">
        <div class="mini-cart-empty" *ngIf="cartItems.length === 0">
          {{ 'pages.catalog.seller.cartEmpty' | i18n }}
        </div>

        <div class="mini-cart-list" *ngIf="cartItems.length > 0">
          <div
            *ngFor="let group of sellerCartGroups; trackBy: trackSellerCartGroup"
            class="mini-cart-product"
          >
            <header class="mini-cart-product-header">
              <div class="mini-cart-product-icon">
                <umkt-icon [icon]="getSellerProductIcon()"></umkt-icon>
              </div>
              <div class="mini-cart-product-name">{{ group.name }}</div>
            </header>

            <ul class="mini-cart-plans">
              <li
                *ngFor="let cartItem of group.items; trackBy: trackSellerCartItem"
                class="mini-cart-plan"
              >
                <span class="mini-cart-plan-name">{{ cartItem.variationName }}</span>
                <div class="mini-cart-plan-actions">
                  <div class="qty-counter">
                    <button
                      type="button"
                      (click)="decrementSellerCartQuantity(cartItem)"
                      class="counter-btn"
                      [disabled]="cartItem.quantity <= 1"
                    >
                      -
                    </button>
                    <span class="qty">{{ cartItem.quantity | number: '2.0' }}</span>
                    <button
                      type="button"
                      (click)="incrementSellerCartQuantity(cartItem)"
                      class="counter-btn"
                      [disabled]="cartItem.quantity >= 99 || isBlipGoCatalogItem(cartItem)"
                    >
                      +
                    </button>
                  </div>
                  <span class="mini-cart-plan-price">
                    {{ getSellerCartItemPrice(cartItem) | currencyBRL }}
                    <span class="mini-cart-plan-price__period">
                      {{ getSellerCartItemPeriodKey(cartItem) | i18n }}
                    </span>
                  </span>
                  <button
                    type="button"
                    class="remove-item-btn"
                    (click)="removeFromSellerCart(cartItem, $event)"
                    [title]="'pages.catalog.seller.removeItem' | i18n"
                    [attr.aria-label]="'pages.catalog.seller.removeItem' | i18n"
                  >
                    <umkt-icon
                      [icon]="{ name: 'trash3', type: 'bootstrap-icons' }"
                      size="sm"
                    ></umkt-icon>
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="mini-cart-footer">
        <div class="mini-cart-total" *ngIf="cartItems.length > 0">
          <span>{{ 'pages.catalog.seller.total' | i18n }}</span>
          <strong>{{ sellerCartTotal | currencyBRL }}</strong>
        </div>

        <div class="input-with-buttons">
          <umkt-custom-input
            [placeholder]="'pages.catalog.product.urlPlaceholder' | i18n"
            [ngModel]="finalizeUrl"
            [showClearButton]="false"
          >
          </umkt-custom-input>

          <div class="action-buttons">
            <button
              type="button"
              class="copy-link-btn"
              [class.copied]="finalizeUrlCopied"
              [disabled]="!canFinalize || !finalizeUrl"
              (click)="copySellerCartLink()"
              [title]="
                (finalizeUrlCopied
                  ? 'pages.catalog.copy.tooltipCopied'
                  : 'pages.catalog.copy.tooltip') | i18n
              "
            >
              <umkt-icon
                *ngIf="!finalizeUrlCopied"
                [icon]="{ name: 'quadrados-copiar', type: 'mondrian-icons' }"
              ></umkt-icon>
              <umkt-icon
                *ngIf="finalizeUrlCopied"
                [icon]="{ name: 'check', type: 'mondrian-icons' }"
              ></umkt-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <umkt-loading
      *ngIf="loading"
      [isLoading]="true"
      [showText]="true"
      [text]="'pages.catalog.loading' | i18n"
      [size]="'md'"
      [mode]="'contained'"
    >
    </umkt-loading>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="error-state">
      <h3>{{ 'pages.catalog.error.title' | i18n }}</h3>
      <p>{{ error }}</p>
      <button class="retry-button" (click)="retry()">
        {{ 'pages.catalog.error.retryButton' | i18n }}
      </button>
    </div>

    <!-- Empty State -->
    <div
      *ngIf="!loading && !error && filteredItems.length === 0"
      class="empty-state"
    >
      <h3>
        {{
          (searchTerm
            ? 'pages.catalog.empty.searchTitle'
            : 'pages.catalog.empty.defaultTitle') | i18n
        }}
      </h3>
      <p>
        {{
          (searchTerm
            ? 'pages.catalog.empty.searchDesc'
            : 'pages.catalog.empty.defaultDesc') | i18n
        }}
      </p>
    </div>

    <div
      *ngIf="!loading && !error && filteredItems.length > 0"
      class="products-list"
    >
      <div *ngFor="let item of filteredItems" class="product-item">
        <div class="product-info">
          <div class="product-header">
            <div class="product-title-section">
              <h3 class="product-name">{{ item.productName }}</h3>
              <p class="variation-name">{{ item.variationName }}</p>
            </div>

            <div class="quantity-section" [class.with-add]="sellerMode">
              <span>{{ 'pages.catalog.product.quantityLabel' | i18n }}</span>
              <div class="quantity-actions">
                <button
                  *ngIf="sellerMode"
                  type="button"
                  class="add-to-seller-cart-btn"
                  [class.just-added]="item.justAdded"
                  [class.disabled]="!hasValidSeller"
                  [disabled]="!hasValidSeller"
                  [title]="
                    (!hasValidSeller
                      ? 'pages.catalog.seller.requireCodeToAdd'
                      : 'pages.catalog.seller.add') | i18n
                  "
                  (click)="addToSellerCart(item)"
                >
                  {{
                    (item.justAdded
                      ? 'pages.catalog.seller.added'
                      : 'pages.catalog.seller.add') | i18n
                  }}
                </button>
                <div class="qty-counter">
                  <button
                    (click)="decrementQuantity(item)"
                    class="counter-btn"
                    [disabled]="item.quantity <= 1"
                  >
                    -
                  </button>
                  <span class="qty">{{ item.quantity | number: '2.0' }}</span>
                  <button
                    (click)="incrementQuantity(item)"
                    class="counter-btn"
                    [disabled]="item.quantity >= 99"
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="input-with-buttons" *ngIf="!sellerMode">
            <umkt-custom-input
              [placeholder]="'pages.catalog.product.urlPlaceholder' | i18n"
              [showClearButton]="false"
              [(ngModel)]="item.generatedUrl"
            >
            </umkt-custom-input>

            <div class="action-buttons">
              <button
                class="copy-link-btn"
                [class.copied]="item.copied"
                (click)="copyCartLink(item)"
                [title]="
                  (item.copied
                    ? 'pages.catalog.copy.tooltipCopied'
                    : 'pages.catalog.copy.tooltip') | i18n
                "
              >
                <umkt-icon
                  *ngIf="!item.copied"
                  [icon]="{ name: 'quadrados-copiar', type: 'mondrian-icons' }"
                ></umkt-icon>
                <umkt-icon
                  *ngIf="item.copied"
                  [icon]="{ name: 'check', type: 'mondrian-icons' }"
                ></umkt-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
